/*
 * EGR — site shell
 * Floating header, shop flyout, mobile sheet, announcement strip, footer,
 * researcher gate, cart drawer, quick view, search palette, toasts, load-in,
 * floating buttons, reveals and shared widgets.
 */
(function () {
  "use strict";

  const EGR = window.EGR;
  const { $, $$, esc, money, moneyShort, fmtDate, storage } = EGR.u;
  const icon = EGR.icon;
  const C = EGR.catalog;
  const P = EGR.data.promo;
  const B = EGR.data.brand;
  const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  const SHOP = window.EGR_SHOP || {};
  const NAV = [
    { id: "store", label: "Shop", href: "store.html", flyout: true },
    { id: "coa", label: "COA library", href: "coa.html" },
    { id: "quality", label: "Quality", href: "quality.html" },
    { id: "wholesale", label: "Wholesale", href: "wholesale.html" },
    { id: "faq", label: "FAQ", href: "faq.html" },
    { id: "contact", label: "Contact", href: "contact.html" }
  ];
  const SECTION_OF = { product: "store", lot: "coa", library: "coa", checkout: "store" };

  /* ------------------------------------------------------------ countdown */
  function etSecondsOfDay(d) {
    const parts = new Intl.DateTimeFormat("en-US", { timeZone: "America/New_York", hour12: false, hour: "2-digit", minute: "2-digit", second: "2-digit" }).formatToParts(d);
    const get = (t) => parseInt((parts.find((p) => p.type === t) || {}).value || "0", 10);
    return (get("hour") % 24) * 3600 + get("minute") * 60 + get("second");
  }
  function dailyRemaining() {
    const reset = (P.daily.resetHourET || 0) * 3600;
    let rem = reset - etSecondsOfDay(new Date());
    if (rem <= 0) rem += 86400;
    return rem;
  }
  const pad = (n) => String(n).padStart(2, "0");
  function hms(sec) { const h = Math.floor(sec / 3600), m = Math.floor((sec % 3600) / 60), s = sec % 60; return { h: pad(h), m: pad(m), s: pad(s) }; }
  function fmtRemaining(sec) {
    const d = Math.floor(sec / 86400);
    const t = hms(sec % 86400);
    return (d ? `${d}d ` : "") + `${t.h}:${t.m}:${t.s}`;
  }
  function tick() {
    const daily = dailyRemaining();
    const site = Math.max(0, Math.floor((EGR.pricing.sitewideEnds() - Date.now()) / 1000));
    $$("[data-countdown]").forEach((el) => { el.textContent = fmtRemaining(el.dataset.countdown === "sitewide" ? site : daily); });
    const t = hms(daily);
    $$("[data-cd]").forEach((el) => { const v = t[el.dataset.cd]; if (el.textContent !== v) el.textContent = v; });
  }
  EGR.countdown = { dailyRemaining, hms };

  /* ---------------------------------------------------------------- toast */
  let toastTimer;
  EGR.toast = function (msg) {
    let el = $(".toast");
    if (!el) { el = document.createElement("div"); el.className = "toast"; el.setAttribute("role", "status"); document.body.appendChild(el); }
    el.textContent = msg;
    el.classList.remove("is-on"); void el.offsetWidth;
    el.classList.add("is-on");
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => el.classList.remove("is-on"), 2600);
  };

  /* -------------------------------------------------------------- reveals */
  let io;
  EGR.onVisible = function (el, fn, opts) {
    if (!("IntersectionObserver" in window)) { fn(el); return; }
    const o = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting) { o.unobserve(e.target); fn(e.target); } });
    }, Object.assign({ threshold: 0.2, rootMargin: "0px 0px -8% 0px" }, opts));
    o.observe(el);
  };
  EGR.reveal = function (root) {
    const els = $$(".reveal:not(.is-in)", root);
    if (!("IntersectionObserver" in window)) { els.forEach((e) => e.classList.add("is-in")); return; }
    io = io || new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add("is-in"); io.unobserve(e.target); } });
    }, { threshold: 0.12, rootMargin: "0px 0px -6% 0px" });
    els.forEach((e) => io.observe(e));
    $$(".chrom.is-pending", root).forEach((svg) => EGR.onVisible(svg, (s) => { requestAnimationFrame(() => { s.classList.remove("is-pending"); s.classList.add("is-drawn"); }); }, { threshold: 0.35 }));
  };

  /* --------------------------------------------------------------- header */
  function flyout() {
    const counts = {};
    C.products.forEach((p) => { counts[p.category] = (counts[p.category] || 0) + 1; });
    const cats = EGR.data.categories.map((c) => `<a href="store.html?cat=${c.id}">${esc(c.label)}<span class="count">${counts[c.id] || 0}</span></a>`).join("");
    return `<div class="gnav-flyout" id="flyout-shop" role="region" aria-label="Shop">
<div class="flyout-inner">
<div class="flyout-col primary"><h4 class="label">Shop by category</h4><a href="store.html">All compounds<span class="count">${C.products.length}</span></a>${cats}<a href="store.html?cat=blends">Blends<span class="count">${C.products.filter(C.isBlend).length}</span></a></div>
<div class="flyout-col"><h4 class="label">Explore</h4><a href="store.html?sort=featured">Best sellers</a><a href="store.html?sort=price-asc">Price: low to high</a><a href="wholesale.html">Wholesale</a><a href="faq.html">FAQ</a></div>
<div class="flyout-col"><h4 class="label">Evidence</h4><a href="coa.html">COA library</a>${C.allLots.length ? `<a href="coa.html#lookup">Look up a lot</a>` : ""}<a href="quality.html">How we test</a><a href="library.html">Compound library</a><a href="shipping.html">Shipping</a></div>
<a class="flyout-feature" href="store.html?sort=featured"><img src="${esc(SHOP.hero || "")}" alt="" loading="lazy" decoding="async" width="1254" height="1254"><span>The EGR line<small>BPC-157 · Reditide · GHK-Cu</small></span></a>
</div></div>`;
  }

  function header(cfg, page) {
    const current = SECTION_OF[page] || page;
    const links = NAV.map((n) => `<li${n.flyout ? ' class="has-flyout"' : ""}><a href="${n.href}"${current === n.id ? ' aria-current="page"' : ""}${n.flyout ? ' aria-haspopup="true" aria-expanded="false" aria-controls="flyout-shop"' : ""}>${n.label}${n.flyout ? icon("chevD") : ""}</a></li>`).join("");
    let html = `<a class="skip-link" href="#main">Skip to content</a>`;
    if (cfg.ribbon) html += ribbon();
    html += `<div class="gnav-wrap"><nav class="gnav" aria-label="Global">
<div class="gnav-inner">
<a class="gnav-logo logo-link" href="index.html" aria-label="${esc(B.name)} home">${EGR.logo("", { tagline: true })}</a>
<ul class="gnav-links">${links}</ul>
<div class="gnav-actions">
<button type="button" class="gnav-icon" data-open-search aria-label="Search compounds, lots and pages">${icon("search")}</button>
<button type="button" class="gnav-icon" data-open-bag aria-label="Cart">${icon("bag")}<span class="bag-count" data-count="0">0</span></button>
<a class="btn btn-sm gnav-account" href="account.html">${icon("user")}Account</a>
<button type="button" class="gnav-icon gnav-menu-btn" data-open-menu aria-label="Menu" aria-expanded="false">${icon("menu")}</button>
</div>
</div>
${flyout()}
</nav></div>
<div class="page-scrim" aria-hidden="true"></div>`;
    return html;
  }

  function ribbon() {
    const st = SHOP.settings || {};
    if (!st.announcement) return "";
    return `<div class="ribbon">${esc(st.announcement)}${st.announcementLink ? `<a href="${esc(st.announcementLink)}">${esc(st.announcementLabel || "Learn more")}</a>` : ""}</div>`;
  }

  function mobileMenu() {
    const primary = NAV.map((n, i) => `<li style="transition-delay:${0.035 * i + 0.08}s"><a href="${n.href}">${n.label}${icon("chevR")}</a></li>`).join("");
    const sec = [["Best sellers", "store.html?sort=featured"], ["Wholesale", "wholesale.html"], ["Compound library", "library.html"], ["FAQ", "faq.html"], ["Shipping", "shipping.html"], ["Account", "account.html"], ["Partner programme", "affiliates.html"]].concat(C.allLots.length ? [["Look up a lot", "coa.html#lookup"]] : []);
    return `<div class="mnav" id="mnav" aria-hidden="true">
<div class="mnav-sheet" role="dialog" aria-modal="true" aria-label="Menu">
<div class="mnav-head">${EGR.logo("", { tagline: false })}<button type="button" class="icon-btn" data-close-menu aria-label="Close menu">${icon("close")}</button></div>
<ul class="mnav-primary">${primary}</ul>
<ul class="mnav-secondary">${sec.map(([l, h], i) => `<li style="transition-delay:${0.32 + 0.025 * i}s"><a href="${h}">${l}</a></li>`).join("")}</ul>
<p class="mnav-foot">Research use only · Not for human or veterinary use.</p>
</div></div>`;
  }

  /* --------------------------------------------------------------- footer */
  function footer() {
    const col = (title, items) => `<div class="footer-col"><h3><button type="button" aria-expanded="false">${title}</button></h3><ul>${items.map(([l, h, isNew]) => `<li><a href="${h}">${l}</a>${isNew ? '<span class="new">New</span>' : ""}</li>`).join("")}</ul></div>`;
    const site = EGR.pricing.sitewideActive()
      ? `<p>${esc(P.sitewide.name)}: ${P.sitewide.percent}% off is applied in the cart until ${new Date(P.sitewide.endsAt).toLocaleString("en-US", { dateStyle: "medium", timeStyle: "short", timeZone: "America/New_York" })} ET.</p>`
      : "";
    return `<footer class="footer" id="site-footer"><div class="footer-inner">
<div class="footer-top">
<div class="footer-brand">
<a class="logo-link" href="index.html" aria-label="${esc(B.name)} home" style="height:auto">${EGR.logo("", { tone: "light" })}</a>
<p>${esc(B.tagline)} For in-vitro laboratory research.</p>
<form class="footer-news" id="news-form" method="post" action="${esc((SHOP.routes && SHOP.routes.root || "/").replace(/\/?$/, "/"))}contact#news-form" accept-charset="UTF-8" novalidate><input type="hidden" name="form_type" value="customer"><input type="hidden" name="utf8" value="✓"><input type="hidden" name="contact[tags]" value="newsletter"><label class="sr-only" for="news-email">Email address</label><input class="input" id="news-email" name="contact[email]" type="email" autocomplete="email" placeholder="Email for new lot releases" required><button type="submit" class="btn btn-light btn-sm">Subscribe</button></form>
<p class="form-note" aria-live="polite"></p>
</div>
<nav class="footer-dir" aria-label="Footer">
${col("Shop", [["All compounds", "store.html"], ["Best sellers", "store.html?sort=featured"], ["Wholesale", "wholesale.html"], ["Cart", "cart.html"]])}
${col("Evidence", [["COA library", "coa.html"]].concat(C.allLots.length ? [["Look up a lot", "coa.html#lookup"]] : [], [["How we test", "quality.html"], ["Compound library", "library.html"]]))}
${col("Support", [["Contact", "contact.html"], ["FAQ", "faq.html"], ["Shipping", "shipping.html"], ["Your account", "account.html"], ["Partner programme", "affiliates.html"]])}
${col("Legal", [["Terms of service", "legal.html?doc=terms"], ["Privacy policy", "legal.html?doc=privacy"], ["Refund policy", "legal.html?doc=returns"], ["Shipping policy", "legal.html?doc=shipping-policy"], ["Research-use policy", "legal.html?doc=research-use"]])}
</nav>
</div>
<div class="footer-notes">
<div class="ruo">${icon("warn")}<div><strong>Research use only.</strong> Products sold by ${esc(B.name)} are intended for in-vitro laboratory research by qualified professionals only. They are not drugs, foods, supplements or cosmetics, have not been evaluated by the U.S. Food and Drug Administration, and are not intended to diagnose, treat, cure or prevent any disease. Not for human or veterinary use.</div></div>
${P.freeShippingOver ? `<p>Free shipping on orders over ${moneyShort(P.freeShippingOver)}. Shipping and taxes are calculated at checkout.</p>` : `<p>Shipping and taxes are calculated at checkout.</p>`}
<p>Questions? ${B.email ? `Email <a href="mailto:${esc(B.email)}">${esc(B.email)}</a>` : `Send us a message on the <a href="contact.html">contact page</a>`}${B.phone ? ` or call <a href="tel:${esc(B.phone.replace(/[^\d+]/g, ""))}">${esc(B.phone)}</a>` : ""} — a person replies ${esc(B.replyTime)}.</p>
${B.address ? `<p>${esc(B.legalName)} · ${esc(B.address)}</p>` : ""}
</div>
<div class="footer-band">
<div class="assure">${[location.protocol === "https:" ? ["lock", "Secure checkout"] : null, ["shield", "Shipment protection"], C.allLots.length ? ["fileCheck", "COA for every lot"] : null].filter(Boolean).map(([i, t]) => `<span>${icon(i)}${t}</span>`).join("")}</div>
${(B.paymentMethods || []).length ? `<div class="pay" aria-label="Accepted payment methods">${B.paymentMethods.map((t) => `<span>${esc(t)}</span>`).join("")}</div>` : ""}
</div>
<div class="footer-legal"><p>© ${new Date().getFullYear()} ${esc(B.legalName)}. All rights reserved. For in-vitro laboratory research only.</p>
<ul><li><a href="legal.html?doc=terms">Terms</a></li><li><a href="legal.html?doc=privacy">Privacy</a></li><li><a href="legal.html?doc=returns">Refunds</a></li><li><a href="legal.html?doc=research-use">Research use</a></li></ul></div>
</div></footer>`;
  }
  function wireNews() {
    const form = $("#news-form");
    if (!form) return;
    const note = form.parentElement.querySelector(".form-note");
    if (/[?&]customer_posted=true/.test(location.search)) note.textContent = "Thanks, you're subscribed.";
    form.addEventListener("submit", (e) => {
      const input = $("#news-email");
      const ok = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(input.value.trim());
      if (!ok) { e.preventDefault(); note.textContent = "Enter a valid email address."; input.focus(); }
      // Valid: the form posts to Shopify, which adds the email as a subscribed customer.
    });
  }

  /* ----------------------------------------------------------------- gate */
  function gate() {
    if (!document.documentElement.hasAttribute("data-gate")) return;
    const el = document.createElement("div");
    el.className = "gate";
    el.setAttribute("role", "dialog");
    el.setAttribute("aria-modal", "true");
    el.setAttribute("aria-labelledby", "gate-title");
    const box = `<span class="box">${icon("check")}</span>`;
    const picks = ["bpc-157", "reditide", "ghk-cu", "tesamorelin", "mots-c", "nad-plus", "tb-500", "cjc-ipamorelin", "selank", "klow"].map((h) => C.product(h)).filter(Boolean);
    const rain = reduce ? "" : picks.map((p, i) => {
      const left = 3 + i * 9.6 + (i % 2 ? 2 : -1);
      const w = 64 + ((i * 37) % 52);
      const t = 26 + ((i * 7) % 14);
      const dl = -((i * 11) % 30);
      const r = ((i % 3) - 1) * 11;
      return `<span style="left:${left}%;--w:${w}px;--t:${t}s;--dl:${dl}s;--r:${r}deg;--dx:${(i % 2 ? -1 : 1) * 24}px;--o:${0.55 + (w - 64) / 120}">${EGR.vial(p)}</span>`;
    }).join("");
    el.innerHTML = `<div class="gate-rain" aria-hidden="true">${rain}</div>
<div class="gate-stack">
${EGR.logo("", { tagline: true })}
<div class="gate-card">
<div class="gate-top"><span class="badge">Research use only</span><span class="gate-count" aria-live="polite"><span data-gate-n>0</span> of 2 confirmed</span></div>
<h1 id="gate-title">Researcher verification</h1>
<p>${esc(B.name)} supplies research compounds exclusively for in-vitro and laboratory work. Confirm both statements to continue.</p>
<div class="gate-checks">
<label class="check"><input type="checkbox" id="gate-a">${box}<span>I am at least 21 years of age.</span></label>
<label class="check"><input type="checkbox" id="gate-b">${box}<span>I am a qualified researcher purchasing for in-vitro or laboratory research only, not for human or veterinary use.</span></label>
</div>
<button type="button" class="btn btn-lg btn-block btn-arrow" id="gate-enter" disabled>Enter ${esc(B.name)}<span class="btn-badge">${icon("arrow")}</span></button>
<p class="gate-fine">By continuing you confirm both statements are true. Products are not for human or veterinary use and are not intended for diagnostic procedures. <a href="legal.html?doc=disclaimer">Full disclaimer</a>.</p>
<p class="gate-leave">Not a researcher?<a href="https://www.google.com">Leave the site</a></p>
</div></div>`;
    document.body.appendChild(el);
    const a = $("#gate-a", el), b = $("#gate-b", el), go = $("#gate-enter", el), n = $("[data-gate-n]", el);
    const sync = () => {
      go.disabled = !(a.checked && b.checked);
      n.textContent = (a.checked ? 1 : 0) + (b.checked ? 1 : 0);
      [a, b].forEach((x) => x.closest(".check").classList.toggle("is-checked", x.checked));
    };
    a.addEventListener("change", sync); b.addEventListener("change", sync);
    go.addEventListener("click", () => {
      storage("egr_researcher", 1);
      try { document.cookie = "egr_researcher=1; max-age=31536000; path=/; SameSite=Lax"; } catch (e) { /* file:// */ }
      try { sessionStorage.setItem("egr_intro", "1"); } catch (e) { /* private mode */ }
      el.classList.add("is-leaving");
      document.documentElement.removeAttribute("data-gate");
      ready();
      setTimeout(() => el.remove(), 520);
    });
    el.addEventListener("keydown", (e) => {
      if (e.key !== "Tab") return;
      const f = $$("input, button:not([disabled]), a[href]", el);
      const first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
    setTimeout(() => a.focus({ preventScroll: true }), 60);
  }

  /* ---------------------------------------------------------------- drawer */
  let lastFocus = null;
  function drawerShell() {
    const wrap = document.createElement("div");
    wrap.innerHTML = `<div class="overlay" data-close-bag></div>
<aside class="drawer" id="bag" role="dialog" aria-modal="true" aria-labelledby="bag-title" aria-hidden="true">
<div class="drawer-head"><h2 id="bag-title">Cart<small data-bag-n></small></h2><button type="button" class="icon-btn" data-close-bag aria-label="Close cart">${icon("close")}</button></div>
<div class="drawer-body" id="bag-body"></div>
<div class="drawer-foot" id="bag-foot"></div>
</aside>`;
    document.body.append(...wrap.children);
  }
  function lineHtml(l) {
    if (l.t === "box") {
      const items = l.items.map((id) => C.variant(id)).filter(Boolean);
      const first = items[0];
      const names = items.map((x) => `${esc(x.product.short)} ${esc(x.variant.title)}`).join(" · ");
      const gift = C.product(P.box.freeGiftHandle);
      return `<div class="bag-line">
${first ? EGR.thumb(first.product, first.variant) : ""}
<div class="grow">
<div class="t"><span>Monthly box</span><span class="amt">${money(l.pricing.total)}<span class="faint" style="font-weight:600">/mo</span></span></div>
<div class="was">${money(l.pricing.retail)}</div>
<div class="box-items">${names}${gift ? ` · <span class="text-pass">${esc(gift.title)} free</span>` : ""}</div>
<div class="s">Billed monthly · ${P.box.deliveries} deliveries to start, then cancel anytime</div>
<div class="ctrls"><span class="d">−${P.box.percent}% box pricing</span><button type="button" class="linkish" data-remove="${l.key}">Remove</button></div>
</div></div>`;
    }
    const p = l.product, v = l.variant, lt = C.activeLot(v);
    const was = l.lineTotal < l.pricing.retail ? `<div class="was">${money(l.pricing.retail)}</div>` : "";
    const tag = l.pricing.label ? `<span class="d">${esc(l.pricing.label)}</span>` : "";
    return `<div class="bag-line">
${EGR.thumb(p, v)}
<div class="grow">
<div class="t"><a href="product.html?p=${p.handle}">${esc(p.title)}</a><span class="amt">${money(l.lineTotal)}</span></div>
${was}
<div class="s">${esc(v.title)}${lt ? ` · LOT ${lt.number}` : ""} · ${money(v.price)} each</div>
${tag}
<div class="ctrls"><div class="stepper" role="group" aria-label="Quantity for ${esc(p.title)}"><button type="button" data-qty-step="-1" data-key="${l.key}" aria-label="Decrease">${icon("minus")}</button><input type="number" min="1" max="999" inputmode="numeric" value="${l.q}" data-qty-input="${l.key}" aria-label="Quantity"><button type="button" data-qty-step="1" data-key="${l.key}" aria-label="Increase">${icon("plus")}</button></div><button type="button" class="linkish" data-remove="${l.key}">Remove</button></div>
</div></div>`;
  }
  EGR.cartLineHtml = lineHtml;
  function renderBag() {
    const body = $("#bag-body"), foot = $("#bag-foot");
    if (!body) return;
    const t = EGR.bag.totals();
    const n = EGR.bag.count();
    $$(".bag-count").forEach((el) => { if (el.textContent !== String(n)) { el.textContent = n; el.dataset.count = n; el.classList.remove("bag-bump"); void el.offsetWidth; el.classList.add("bag-bump"); } });
    $$("[data-open-bag]").forEach((b) => b.setAttribute("aria-label", `Cart, ${n} item${n === 1 ? "" : "s"}`));
    const bn = $("[data-bag-n]");
    if (bn) bn.textContent = n ? `${n} item${n === 1 ? "" : "s"}` : "";
    const fab = $(".fab-cart");
    if (fab) fab.classList.toggle("is-on", n > 0);
    if (!t.lines.length) {
      body.innerHTML = `<div class="empty">${icon("bag", "icon-lg")}<h3>Your cart is empty.</h3><p>Browse the catalog to add a compound.</p><div class="btn-row"><a class="btn" href="store.html">Shop compounds</a></div></div>`;
      foot.innerHTML = "";
      foot.hidden = true;
      return;
    }
    foot.hidden = false;
    const pct = P.freeShippingOver ? Math.min(100, (t.total / P.freeShippingOver) * 100) : 0;
    const meter = !P.freeShippingOver ? "" : t.freeShipping
      ? `<div class="ship-meter"><span class="text-pass">${icon("check", "icon")}</span> <strong>Free shipping</strong> on this order.</div>`
      : `<div class="ship-meter">Add <strong>${money(t.toFree)}</strong> more for free shipping.<div class="progress"><span style="width:${pct}%"></span></div></div>`;
    body.innerHTML = meter + t.lines.map(lineHtml).join("");
    const sav = t.savings.map((s) => `<div><span>${esc(s.label)}</span><span class="neg">−${money(s.amount)}</span></div>`).join("");
    foot.innerHTML = `<div class="sum">
${sav ? `<div><span>Subtotal</span><span>${money(t.retail)}</span></div>
${sav}
<div class="total"><span>Subtotal after discounts</span><span>${money(t.total)}</span></div>` : `<div class="total"><span>Subtotal</span><span>${money(t.total)}</span></div>`}
</div>
<a class="btn btn-lg btn-block btn-arrow" href="checkout.html">Check out<span class="btn-badge">${icon("arrow")}</span></a>
<p class="fine">Shipping and taxes calculated at checkout · <a href="cart.html">View cart</a></p>`;
  }
  function openBag() {
    lastFocus = document.activeElement;
    closeQuick(true);
    $(".overlay").classList.add("is-open");
    const d = $("#bag");
    d.classList.add("is-open");
    d.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
    setTimeout(() => { const c = $("#bag [data-close-bag]"); c && c.focus(); }, 60);
  }
  function closeBag() {
    $(".overlay").classList.remove("is-open");
    const d = $("#bag");
    d.classList.remove("is-open");
    d.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  EGR.openBag = openBag;
  EGR.closeBag = closeBag;

  /* ------------------------------------------------------------ quick view */
  let qvLast = null;
  function quickShell() {
    const el = document.createElement("div");
    el.className = "qv";
    el.setAttribute("aria-hidden", "true");
    el.innerHTML = `<div class="qv-card" role="dialog" aria-modal="true" aria-labelledby="qv-title"><div class="qv-head"><span class="label">Quick view</span><button type="button" class="icon-btn" data-close-quick aria-label="Close quick view">${icon("close")}</button></div><div class="qv-grid" id="qv-grid"></div></div>`;
    document.body.appendChild(el);
    el.addEventListener("click", (e) => { if (e.target === el) closeQuick(); });
  }
  function quickView(handle) {
    const p = C.product(handle);
    if (!p) return;
    qvLast = document.activeElement;
    const el = $(".qv");
    const daily = EGR.pricing.isDaily(p);
    let v = p.variants[0];
    let qty = 1;
    const grid = $("#qv-grid");
    function draw() {
      const lt = C.activeLot(v);
      const price = daily ? EGR.pricing.dailyPrice(v) : v.price;
      grid.innerHTML = `<div class="stage tone-${p.tone}" style="--acc:${EGR.accent(p)}">${EGR.stage(p, { variant: v, large: true })}</div>
<div class="qv-body" data-handle="${esc(p.handle)}">
<h2 id="qv-title">${esc(p.title)}</h2>
<p class="sub">${esc(p.subtitle)}</p>
<div class="qv-facts">${lt ? `<span>${icon("check")}${lt.purity != null ? `${lt.purity.toFixed(2)}% HPLC` : "Lot released"}</span><span>${icon("fileCheck")}LOT ${lt.number}</span>` : ""}<span>${icon("snow")}Ships in 0–2 days</span><span>${icon("warn")}Research use only</span></div>
<div class="qv-sizes" role="radiogroup" aria-label="Size">${p.variants.map((x) => { const pr = daily ? EGR.pricing.dailyPrice(x) : x.price; return `<button type="button" class="qv-size" role="radio" aria-checked="${x === v}" aria-pressed="${x === v}" data-qv-size="${x.id}"><b>${esc(x.title)}</b><span>${money(pr)}</span></button>`; }).join("")}</div>
<div class="qv-total"><div class="stepper lg" role="group" aria-label="Quantity"><button type="button" data-qv-step="-1" aria-label="Decrease">${icon("minus")}</button><input type="number" min="1" max="999" value="${qty}" data-qv-qty aria-label="Quantity"><button type="button" data-qv-step="1" aria-label="Increase">${icon("plus")}</button></div><strong>${money(EGR.pricing.line(p, v, qty).total)}</strong></div>
<div class="qv-actions"><button type="button" class="btn" data-add="${v.id}" data-qty="${qty}"${v.stock === 0 ? " disabled" : ""}>${icon("bag")}${v.stock === 0 ? "Sold out" : "Add to cart"}</button><a class="btn btn-outline" href="product.html?p=${p.handle}${v === p.variants[0] ? "" : "&v=" + v.title.replace(/\s+/g, "").toLowerCase()}">Full details</a></div>
<p class="caption muted">For in-vitro laboratory research only. Not for human or veterinary use.</p>
</div>`;
    }
    draw();
    grid.onclick = (e) => {
      const s = e.target.closest("[data-qv-size]");
      if (s) { v = C.variant(s.dataset.qvSize).variant; draw(); const b = grid.querySelector(`[data-qv-size="${v.id}"]`); b && b.focus(); return; }
      const st = e.target.closest("[data-qv-step]");
      if (st) { qty = Math.max(1, Math.min(999, qty + parseInt(st.dataset.qvStep, 10))); draw(); return; }
    };
    grid.onchange = (e) => { if (e.target.matches("[data-qv-qty]")) { qty = Math.max(1, Math.min(999, parseInt(e.target.value, 10) || 1)); draw(); } };
    el.classList.add("is-open");
    el.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
    setTimeout(() => { const c = $("[data-close-quick]", el); c && c.focus(); }, 60);
  }
  function closeQuick(silent) {
    const el = $(".qv");
    if (!el || !el.classList.contains("is-open")) return;
    el.classList.remove("is-open");
    el.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
    if (!silent && qvLast && qvLast.focus) qvLast.focus({ preventScroll: true });
  }
  EGR.quickView = quickView;

  /* --------------------------------------------------------------- search */
  const PAGES = [
    ["Shop all compounds", "store.html", "store"], ["Best sellers", "store.html?sort=featured", "star"],
    ["Cart", "cart.html", "bag"], ["COA library", "coa.html", "fileCheck"], ["How we test", "quality.html", "flask"],
    ["Compound library", "library.html", "book"], ["Wholesale", "wholesale.html", "building"],
    ["Contact", "contact.html", "mail"], ["FAQ", "faq.html", "info"], ["Shipping", "shipping.html", "truck"],
    ["Your account", "account.html", "user"], ["Partner programme", "affiliates.html", "handshake"],
    ["Terms of service", "legal.html?doc=terms", "book"], ["Privacy policy", "legal.html?doc=privacy", "shield"],
    ["Research-use policy", "legal.html?doc=research-use", "warn"], ["Refund policy", "legal.html?doc=returns", "swap"]
  ];
  const norm = (s) => String(s || "").toLowerCase().normalize("NFKD").replace(/[^a-z0-9+]/g, "");
  const index = C.products.map((p) => ({
    p, keys: [p.title, p.short, p.handle, p.subtitle, C.catLabel(p.category)].concat(p.aliases || []).concat((p.components || []).map((c) => c.name)).map(norm)
  }));
  function search(q) {
    const n = norm(q);
    if (!n) return { products: C.featured.slice(0, 6), lots: [], pages: PAGES.slice(0, 6), empty: true };
    const products = index.map((x) => {
      let score = 0;
      x.keys.forEach((k, i) => {
        if (k.startsWith(n)) score = Math.max(score, i < 3 ? 100 : i === 4 ? 30 : 60);
        else if (i !== 4 && k.includes(n) && (i !== 3 || n.length >= 3)) score = Math.max(score, i < 3 ? 70 : 40);
      });
      return { p: x.p, score };
    }).filter((x) => x.score).sort((a, b) => b.score - a.score).slice(0, 7).map((x) => x.p);
    const lots = C.allLots.filter((x) => norm(x.lot.number).includes(n) || (n.length > 2 && products.indexOf(x.product) >= 0 && /\d/.test(n))).slice(0, 5);
    const pages = PAGES.filter((pg) => norm(pg[0]).includes(n)).slice(0, 5);
    return { products, lots, pages };
  }
  EGR.search = search;
  function paletteShell() {
    const el = document.createElement("div");
    el.className = "palette-wrap";
    el.innerHTML = `<div class="palette" role="dialog" aria-modal="true" aria-label="Search">
<div class="palette-input">${icon("search")}<input type="search" placeholder="Search compounds, lots and pages" aria-label="Search" autocomplete="off" spellcheck="false" id="palette-q"><kbd>esc</kbd></div>
<div class="palette-results" id="palette-results" role="listbox"></div>
<div class="palette-foot"><span>↑↓ to move</span><span>↵ to open</span><span>Try “BPC”, “2609-017” or “reditide”</span></div>
</div>`;
    document.body.appendChild(el);
    const input = $("#palette-q", el), results = $("#palette-results", el);
    let active = 0;
    function render() {
      const r = search(input.value);
      let html = "";
      if (r.products.length) {
        html += `<div class="palette-group label">${r.empty ? "Popular compounds" : "Compounds"}</div>` + r.products.map((p) => {
          const v = p.variants[0], lt = C.activeLot(v);
          return `<a class="palette-item" role="option" href="product.html?p=${p.handle}">${EGR.thumb(p, v)}<span class="grow"><span class="n">${esc(p.title)}</span><span class="m">${esc(p.subtitle)}${lt && lt.purity != null ? ` · ${lt.purity.toFixed(2)}%` : ""}</span></span><span class="r">${money(v.price)}</span></a>`;
        }).join("");
      }
      if (r.lots.length) {
        html += `<div class="palette-group label">Lots</div>` + r.lots.map((x) => `<a class="palette-item" role="option" href="lot.html?lot=${x.lot.number}"><span class="pi-icon">${icon("fileCheck")}</span><span class="grow"><span class="n tnum">LOT ${x.lot.number}</span><span class="m">${esc(x.product.title)} · ${esc(x.variant.title)} · tested ${fmtDate(x.lot.testedAt)}</span></span><span class="r">${x.lot.purity != null ? x.lot.purity.toFixed(2) + "%" : ""}</span></a>`).join("");
      }
      if (r.pages.length) {
        html += `<div class="palette-group label">${r.empty ? "Go to" : "Pages"}</div>` + r.pages.map((pg) => `<a class="palette-item" role="option" href="${pg[1]}"><span class="pi-icon">${icon(pg[2] === "store" ? "bag" : pg[2])}</span><span class="grow"><span class="n">${esc(pg[0])}</span></span></a>`).join("");
      }
      results.innerHTML = html || `<div class="palette-empty">No results for “${esc(input.value)}”.<br><a class="more" href="store.html">Browse all compounds</a></div>`;
      active = 0; mark();
    }
    function mark() {
      const items = $$(".palette-item", results);
      items.forEach((it, i) => { it.classList.toggle("is-active", i === active); it.setAttribute("aria-selected", i === active); });
      if (items[active]) items[active].scrollIntoView({ block: "nearest" });
    }
    input.addEventListener("input", render);
    input.addEventListener("keydown", (e) => {
      const items = $$(".palette-item", results);
      if (e.key === "ArrowDown") { e.preventDefault(); active = Math.min(items.length - 1, active + 1); mark(); }
      else if (e.key === "ArrowUp") { e.preventDefault(); active = Math.max(0, active - 1); mark(); }
      else if (e.key === "Enter") { e.preventDefault(); if (items[active]) location.href = items[active].getAttribute("href"); else if (input.value.trim()) location.href = EGR.url("store.html?q=" + encodeURIComponent(input.value.trim())); }
      else if (e.key === "Escape") closePalette();
    });
    results.addEventListener("mousemove", (e) => { const it = e.target.closest(".palette-item"); if (!it) return; const i = $$(".palette-item", results).indexOf(it); if (i !== active) { active = i; mark(); } });
    el.addEventListener("click", (e) => { if (e.target === el) closePalette(); });
    el._render = render;
  }
  function openPalette() {
    const el = $(".palette-wrap");
    lastFocus = document.activeElement;
    el.classList.add("is-open");
    const input = $("#palette-q");
    input.value = "";
    el._render();
    setTimeout(() => input.focus(), 30);
  }
  function closePalette() { const el = $(".palette-wrap"); el.classList.remove("is-open"); if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true }); }
  EGR.openSearch = openPalette;

  /* ---------------------------------------------------------- nav behaviour */
  function wireNav() {
    const nav = $(".gnav");
    const trigger = $(".has-flyout > a");
    const fly = $("#flyout-shop");
    const scrim = $(".page-scrim");
    let t;
    const open = () => { clearTimeout(t); fly.classList.add("is-open"); scrim.classList.add("is-open"); trigger.setAttribute("aria-expanded", "true"); trigger.parentElement.classList.add("is-open"); };
    const close = (now) => { clearTimeout(t); const run = () => { fly.classList.remove("is-open"); scrim.classList.remove("is-open"); trigger.setAttribute("aria-expanded", "false"); trigger.parentElement.classList.remove("is-open"); }; if (now === true) run(); else t = setTimeout(run, 160); };
    if (trigger && window.matchMedia("(hover: hover)").matches) {
      trigger.parentElement.addEventListener("mouseenter", open);
      trigger.parentElement.addEventListener("mouseleave", close);
      fly.addEventListener("mouseenter", open);
      fly.addEventListener("mouseleave", close);
      $$(".gnav-links li:not(.has-flyout)").forEach((li) => li.addEventListener("mouseenter", () => close(true)));
    }
    if (trigger) {
      trigger.addEventListener("focus", open);
      fly.addEventListener("focusout", (e) => { if (!fly.contains(e.relatedTarget) && e.relatedTarget !== trigger) close(); });
      trigger.addEventListener("blur", (e) => { if (!fly.contains(e.relatedTarget)) close(); });
      document.addEventListener("keydown", (e) => { if (e.key === "Escape" && fly.classList.contains("is-open")) close(true); });
    }
    scrim.addEventListener("click", () => close(true));
    const onScroll = () => nav.classList.toggle("is-scrolled", window.scrollY > 8);
    window.addEventListener("scroll", onScroll, { passive: true }); onScroll();
  }
  function openMenu() {
    const m = $("#mnav");
    m.classList.add("is-open"); m.setAttribute("aria-hidden", "false");
    $("[data-open-menu]").setAttribute("aria-expanded", "true");
    document.body.style.overflow = "hidden";
    setTimeout(() => $("#mnav [data-close-menu]").focus(), 40);
  }
  function closeMenu() {
    const m = $("#mnav");
    if (!m.classList.contains("is-open")) return;
    m.classList.remove("is-open"); m.setAttribute("aria-hidden", "true");
    $("[data-open-menu]").setAttribute("aria-expanded", "false");
    document.body.style.overflow = "";
  }

  /* ------------------------------------------------------ shared widgets */
  EGR.wireRails = function (root) {
    $$(".rail", root).forEach((rail) => {
      const track = $(".rail-track", rail);
      const prev = $("[data-rail-prev]", rail), next = $("[data-rail-next]", rail);
      if (!track || !prev) return;
      const sync = () => {
        prev.disabled = track.scrollLeft <= 4;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      };
      const by = () => Math.max(280, track.clientWidth * 0.8);
      prev.addEventListener("click", () => track.scrollBy({ left: -by(), behavior: reduce ? "auto" : "smooth" }));
      next.addEventListener("click", () => track.scrollBy({ left: by(), behavior: reduce ? "auto" : "smooth" }));
      track.addEventListener("scroll", sync, { passive: true });
      window.addEventListener("resize", sync);
      sync();
    });
  };
  EGR.rail = function (cards, opts) {
    opts = opts || {};
    return `<div class="rail"><div class="rail-track" role="region" aria-label="${esc(opts.label || "Products")}" tabindex="0">${cards}</div>
<div class="paddles"><button type="button" class="paddle" data-rail-prev aria-label="Previous">${icon("chevL")}</button><button type="button" class="paddle" data-rail-next aria-label="Next">${icon("chevR")}</button></div></div>`;
  };
  EGR.wireFaq = function (root) {
    $$(".faq-q", root).forEach((q) => {
      if (q.dataset.wired) return;
      q.dataset.wired = "1";
      q.addEventListener("click", () => {
        const item = q.closest(".faq-item");
        const open = !item.classList.contains("is-open");
        const group = item.parentElement;
        if (open && group && group.dataset.single !== undefined) {
          $$(".faq-item.is-open", group).forEach((x) => { x.classList.remove("is-open"); const b = $(".faq-q", x); b && b.setAttribute("aria-expanded", "false"); });
        }
        item.classList.toggle("is-open", open);
        q.setAttribute("aria-expanded", open);
      });
    });
  };
  EGR.faqHtml = function (items, opts) {
    opts = opts || {};
    return `<div class="faq"${opts.single ? " data-single" : ""}>${items.map(([q, a], i) => `<div class="faq-item${opts.reveal ? " reveal" : ""}" id="faq-${i}"${opts.reveal ? ` style="--d:${(i * 0.05).toFixed(2)}s"` : ""}><h3><button type="button" class="faq-q" aria-expanded="false" aria-controls="faq-a-${i}"><span class="num">${String(i + 1).padStart(2, "0")}</span><span class="qt">${esc(q)}</span><span class="plus">${icon("plus")}</span></button></h3><div class="faq-a" id="faq-a-${i}" role="region"><div><p>${a}</p></div></div></div>`).join("")}</div>`;
  };
  EGR.wireLookup = function (form) {
    if (!form) return;
    const input = $("input", form), msg = $(".lookup-msg", form);
    form.addEventListener("submit", (e) => {
      e.preventDefault();
      const raw = input.value.trim().toUpperCase().replace(/^LOT\s*/, "").replace(/\s+/g, "");
      const n = /^\d{4}\d{3}$/.test(raw) ? raw.slice(0, 4) + "-" + raw.slice(4) : raw;
      if (!n) { msg.textContent = "Enter the lot number printed on your vial, e.g. 2609-017."; msg.classList.add("is-error"); input.focus(); return; }
      if (C.lot(n)) { location.href = EGR.url("lot.html?lot=" + encodeURIComponent(n)); return; }
      msg.textContent = C.allLots.length ? `We couldn't find lot ${n}. Check the number on the label, or browse all certificates.` : `Lot certificates aren't published online yet. Contact us with lot ${n} and we'll send its certificate.`;
      msg.classList.add("is-error");
      input.setAttribute("aria-invalid", "true");
    });
    input.addEventListener("input", () => { msg.textContent = ""; msg.classList.remove("is-error"); input.removeAttribute("aria-invalid"); });
  };
  EGR.lookupHtml = function (id) {
    return `<form class="lookup" novalidate ${id ? `id="${id}"` : ""}><label class="sr-only" for="${id || "lk"}-in">Lot number</label>
<div class="lookup-field"><span class="lbl">Lot</span><input id="${id || "lk"}-in" placeholder="2609-017" autocomplete="off" inputmode="text"><button type="submit" class="btn btn-sm">Look up</button></div>
<p class="lookup-msg" aria-live="polite"></p></form>`;
  };
  EGR.mailtoForm = function (form, subject) {
    if (!form) return;
    form.addEventListener("submit", (e) => {
      e.preventDefault();
      if (!form.reportValidity()) return;
      const data = new FormData(form);
      const lines = [];
      data.forEach((v, k) => { if (String(v).trim()) lines.push(`${k}: ${v}`); });
      const href = `mailto:${B.email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(lines.join("\n"))}`;
      const note = $(".form-note", form);
      if (note) { note.textContent = "Opening your email app with this message filled in…"; note.classList.add("ok"); }
      location.href = href;
    });
  };

  /* Pointer-driven spring tilt (apple-design: respond on pointer-down,
     animate from the current value, critically damped by default). */
  EGR.springTilt = function (el, opts) {
    if (!el || reduce || !window.matchMedia("(pointer: fine)").matches) return;
    opts = Object.assign({ max: 9, depth: 1, stiffness: 170, damping: 26, press: 0.975 }, opts);
    let tx = 0, ty = 0, x = 0, y = 0, vx = 0, vy = 0, s = 1, vs = 0, ts = 1, gx = 50, gy = 30, raf = 0, last = 0;
    const mirror = Array.from(opts.mirror || []);
    function step(now) {
      const dt = Math.min(0.032, (now - (last || now)) / 1000 || 0.016);
      last = now;
      const k = opts.stiffness, c = opts.damping;
      vx += (k * (tx - x) - c * vx) * dt; x += vx * dt;
      vy += (k * (ty - y) - c * vy) * dt; y += vy * dt;
      vs += (420 * (ts - s) - 24 * vs) * dt; s += vs * dt;
      el.style.setProperty("--rx", (-y * opts.max).toFixed(3) + "deg");
      el.style.setProperty("--ry", (x * opts.max).toFixed(3) + "deg");
      el.style.setProperty("--px", x.toFixed(4));
      el.style.setProperty("--py", y.toFixed(4));
      el.style.setProperty("--ps", s.toFixed(4));
      el.style.setProperty("--gx", gx.toFixed(1) + "%");
      el.style.setProperty("--gy", gy.toFixed(1) + "%");
      mirror.forEach((m) => { m.style.setProperty("--px", x.toFixed(4)); m.style.setProperty("--py", y.toFixed(4)); });
      const moving = Math.abs(tx - x) + Math.abs(ty - y) + Math.abs(vx) + Math.abs(vy) + Math.abs(ts - s) + Math.abs(vs) > 0.0008;
      raf = moving ? requestAnimationFrame(step) : 0;
      if (!moving) last = 0;
    }
    const kick = () => { if (!raf) raf = requestAnimationFrame(step); };
    const host = opts.host || el;
    host.addEventListener("pointermove", (e) => {
      const r = el.getBoundingClientRect();
      const px = (e.clientX - r.left) / r.width, py = (e.clientY - r.top) / r.height;
      tx = Math.max(-1, Math.min(1, (px - 0.5) * 2));
      ty = Math.max(-1, Math.min(1, (py - 0.5) * 2));
      gx = px * 100; gy = py * 100;
      el.classList.add("is-tilting");
      kick();
    });
    host.addEventListener("pointerleave", () => { tx = 0; ty = 0; ts = 1; gx = 50; gy = 30; el.classList.remove("is-tilting"); kick(); });
    host.addEventListener("pointerdown", () => { ts = opts.press; kick(); });
    window.addEventListener("pointerup", () => { if (ts !== 1) { ts = 1; vs += 1.6; kick(); } });
  };

  /* -------------------------------------------------------- global events */
  function wireGlobal() {
    document.addEventListener("click", (e) => {
      const t = e.target;
      const add = t.closest("[data-add]");
      if (add) {
        e.preventDefault();
        if (add.disabled) return;
        const qty = parseInt(add.dataset.qty || "1", 10);
        EGR.bag.add(add.dataset.add, qty);
        const ref = C.variant(add.dataset.add);
        closeQuick(true);
        openBag();
        if (ref) EGR.toast(`Added ${qty > 1 ? qty + " × " : ""}${ref.product.title} ${ref.variant.title}`);
        return;
      }
      const quick = t.closest("[data-quick]");
      if (quick) { e.preventDefault(); quickView(quick.dataset.quick); return; }
      if (t.closest("[data-close-quick]")) { e.preventDefault(); closeQuick(); return; }
      if (t.closest("[data-open-bag]")) { e.preventDefault(); openBag(); return; }
      if (t.closest("[data-close-bag]")) { e.preventDefault(); closeBag(); return; }
      if (t.closest("[data-open-search]")) { e.preventDefault(); closeMenu(); openPalette(); return; }
      if (t.closest("[data-open-menu]")) { openMenu(); return; }
      if (t.closest("[data-close-menu]") || t.id === "mnav") { closeMenu(); return; }
      if (t.closest("[data-open-chat]")) { e.preventDefault(); if (EGR.chat) EGR.chat.open(t.closest("[data-open-chat]").dataset.openChat); return; }
      const rm = t.closest("[data-remove]");
      if (rm) { EGR.bag.remove(rm.dataset.remove); return; }
      const step = t.closest("[data-qty-step]");
      if (step) {
        const l = EGR.bag.lines().find((x) => x.key === step.dataset.key);
        if (l) EGR.bag.setQty(l.key, l.q + parseInt(step.dataset.qtyStep, 10));
        return;
      }
      const row = t.closest("tr[data-href]");
      if (row && !t.closest("a,button")) { location.href = EGR.url(row.dataset.href); return; }
      const fh = t.closest(".footer-col h3 button");
      if (fh && window.matchMedia("(max-width: 733px)").matches) {
        const col = fh.closest(".footer-col");
        col.classList.toggle("is-open");
        fh.setAttribute("aria-expanded", col.classList.contains("is-open"));
      }
    });
    document.addEventListener("change", (e) => {
      const q = e.target.closest("[data-qty-input]");
      if (q) EGR.bag.setQty(q.dataset.qtyInput, q.value);
    });
    document.addEventListener("keydown", (e) => {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === "k") { e.preventDefault(); openPalette(); return; }
      if (e.key === "/" && !/input|textarea|select/i.test((document.activeElement || {}).tagName || "") && !document.documentElement.hasAttribute("data-gate")) { e.preventDefault(); openPalette(); return; }
      if (e.key === "Escape") {
        if ($(".qv.is-open")) { closeQuick(); return; }
        if ($("#bag") && $("#bag").classList.contains("is-open")) closeBag();
        if ($(".palette-wrap.is-open")) closePalette();
        closeMenu();
      }
    });
  }

  function fabs() {
    const wrap = document.createElement("div");
    wrap.innerHTML = `<button type="button" class="fab fab-cart" data-open-bag aria-label="Cart">${icon("bag")}<span class="bag-count" data-count="0">0</span></button>`;
    document.body.append(...wrap.children);
  }

  /* ------------------------------------------------------------- load-in */
  let isReady = false;
  function ready() {
    if (isReady) return;
    isReady = true;
    document.documentElement.setAttribute("data-ready", "1");
    document.dispatchEvent(new Event("egr:ready"));
  }
  function intro(done) {
    const html = document.documentElement;
    if (!html.classList.contains("intro")) { done(); return; }
    try { sessionStorage.setItem("egr_intro", "1"); } catch (e) { /* private mode */ }
    const el = document.createElement("div");
    el.className = "intro";
    el.setAttribute("aria-hidden", "true");
    el.innerHTML = EGR.logo("", { tagline: true });
    document.body.appendChild(el);
    setTimeout(() => {
      el.classList.add("is-done");
      html.classList.remove("intro");
      done();
      setTimeout(() => el.remove(), 600);
    }, 1050);
  }

  /* ----------------------------------------------------------------- boot */
  function boot() {
    const page = document.body.dataset.page || "page";
    const cfg = (EGR.pages && EGR.pages[page]) || {};
    const head = $("#egr-header");
    if (head) head.outerHTML = header(cfg, page) + mobileMenu();
    const foot = $("#egr-footer");
    if (foot) foot.outerHTML = footer();
    drawerShell();
    quickShell();
    paletteShell();
    fabs();
    wireNav();
    wireGlobal();
    wireNews();
    EGR.bag.on(renderBag);
    renderBag();
    if (cfg.title) document.title = cfg.title;
    try { if (cfg.init) cfg.init(); } catch (err) { console.error(err); }
    EGR.reveal(document);
    EGR.wireRails(document);
    EGR.wireFaq(document);
    if (EGR.chat) EGR.chat.init();
    tick();
    setInterval(tick, 1000);
    gate();
    if (!document.documentElement.hasAttribute("data-gate")) intro(ready);
  }
  // Deferred scripts run while readyState is "interactive", before page scripts load,
  // so wait for DOMContentLoaded unless the document has already finished loading.
  let booted = false;
  const once = () => { if (!booted) { booted = true; boot(); } };
  if (document.readyState === "complete") once(); else document.addEventListener("DOMContentLoaded", once);
})();
